import { Subsidiary } from '@coolblue-development/constants';

export const tooltipTextMap = {
  [Subsidiary.BE]:
    "Deze vacature bestaat niet in het Frans / Ce poste vacant n'existe pas en français",
  [Subsidiary.DE]:
    'Diese Stelle ist nicht auf Englisch verfügbar / This vacancy is unavailable in English',
  [Subsidiary.NL]:
    'Deze vacature bestaat niet in het Engels / This vacancy does not exist in English'
};
